import { api } from "@/services/api/createAPI";
import { getAuthToken } from "@/services/supabase/auth/actions/getAuthToken";
import { useQueryClient } from "@tanstack/react-query";

export const getConnectorTablePreview = async (connectorId: string, tableName: string) => {
  const apiKey = await getAuthToken();
  const { data } = await api(apiKey).post("/api/sql/table_preview", { connectorId, tableName });

  if (!data) {
    return null;
  }

  return data.tablePreview as any[];
};

export const useConnectorTablePreview = () => {
  const queryClient = useQueryClient();

  return async (connectorId: string, tableName: string) => {
    const queryKey = ["connector_table_preview", connectorId, tableName];
    const cached = queryClient.getQueryData<any[]>(queryKey);

    if (cached) {
      return cached;
    }

    const data = await getConnectorTablePreview(connectorId, tableName);
    queryClient.setQueryData(queryKey, data);

    return data;
  };
};
